<!-- Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved. -->
<template>
  <v-img
    src="../assets/backgroundHome.png"
    srcset="../assets/backgroundHome@2x.png 2x,
             ../assets/backgroundHome@3x.png 3x"
    class="backgroundHome"
  >
    <v-container style="margin:0;padding:0;" fluid>
      <v-row align="center" justify="center" style="height:100vh;width:100vw" dense>
        <v-col cols="12" sm="5" xl="6" lg="6" md="6" class="d-flex d-xl-flex d-sm-flex d-lg-flex d-md-flex flex-column justify-center align-center">
          <div class="text-center font-weight-medium text-caption text-sm-body-2 text-md-body-1 text-lg-h6 text-xl-h4">{{ portalTitle }}</div>
        </v-col>
        <v-col
          cols="12"
          sm="7"
          xl="6"
          lg="6"
          md="6"
          style="background-color:rgba(255, 255, 255, 0.6)"
          class=" fill-height d-xl-flex d-sm-flex d-lg-flex d-md-flex flex-column  justify-center align-right"
        >
          <v-row>
            <v-col cols="12" class=" d-xl-flex d-sm-flex d-lg-flex d-md-flex flex-column  justify-center align-center">
              <flightpath-sign-in :baseUrl="appConfigBaseUrl" v-if="formState === 'signIn'"></flightpath-sign-in>
              <v-dialog v-model="dialog" persistent max-width="430px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="d-flex" text color="gray" v-bind="attrs" v-on="on">
                    <v-icon left>mdi-chevron-right</v-icon>{{ $t('auth.forgot_password') }}</v-btn
                  >
                </template>
                <v-card>
                  <flightpath-new-password v-bind:dialog.sync="dialog"></flightpath-new-password>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
import { FlightpathSignIn, FlightpathNewPassword } from '@jca/flightpath-components';
import { FlightPathAxios } from '@/services/api';
export default {
  name: 'Auth',
  data() {
    return {
      formState: 'signIn',
      dialog: false,
      appConfigBaseUrl: new FlightPathAxios().flightPathIp
    };
  },
  computed: {
    portalTitle() {
      const workspace = process.env.VUE_APP_WORKSPACE || 'Exxact';
      // Convert "tecnoma-rc" to "Tecnoma RC"
      const displayName = workspace
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      return `${displayName} Admin Portal`;
    }
  },
  methods: {
    bgHeight() {
      return this.$vuetify.breakpoint.height - 40;
    }
  },
  components: {
    FlightpathSignIn,
    FlightpathNewPassword
  }
};
</script>

<style scoped lang="scss">
.backgroundHome {
  width: 100vw;
  height: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 40;
}
</style>
